import React from 'react'
import { graphql, StaticQuery } from "gatsby"
import Layout from '../components/layouts/layout'
import Product from '../components/product/product'

export default function Shop() {  
  return (
    <Layout>
      {/* Tags Row */}
      <div className="flex-auto flex justify-center space-x-3 sticky top-0 bg-white overflow-x-scroll">
        <button className="w-auto my-2 h-9 p-4 flex items-center justify-center rounded-full bg-purple-50 text-purple-700">Latest</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Promotions</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Wedding</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Graduation</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Chain</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Ring</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Silver</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Gold</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >earring</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >bracelets</button>
        <button className="w-auto my-2 h-9 p-4 h-9 flex items-center justify-center rounded-full bg-purple-50 text-purple-700 disabled:opacity-50" type="button" >Other</button>
      </div> 
       <div className="flex flex-wrap justify-around items-start bg-gray-000 h-screen"> 
        <StaticQuery
          query={graphql`
            {
              allRestApiApiProducts {
                edges {
                  node {
                    name
                    category
                    date
                    description
                    id
                    price
                    slug
                    image {
                      high
                    }
                  }
                }
              }
            }
          `}
          render={data =>  
            data.allRestApiApiProducts.edges.map(product =>  <Product data={product.node}/>)
          }
        ></StaticQuery>
      </div>
       
      {/* <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <div className="w-full md:w-1/3 p-2">
          <div className="bg-white shadow-lg hover:shadow-xl rounded-lg ">
            <div className="bg-gray-400 h-64 rounded-t-lg p-4 bg-no-repeat bg-center bg-cover"  >
              <div className="text-right">
                <button className="text-pink-500 hover:text-pink-600 p-2 rounded-full"  >
                  <svg className="w-6 h-6" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="flex justify-between items-start px-2 pt-2">
              <div className="p-2 flex-grow">
                <h1 className="font-medium text-xl font-poppins">Product name</h1>
                <p className="text-gray-500 font-nunito">Short description here</p>
              </div>
              <div className="p-2 text-right">
                <div className="text-teal-500 font-semibold text-lg font-poppins">$40</div>
                <div className="text-xs text-gray-500 line-through font-poppins">$80</div>
              </div>
            </div>
            <div className="flex justify-center items-center px-2 pb-2">
              <div className="w-1/2 p-2">
                <button className="block w-full bg-teal-500 hover:bg-teal-600 text-white border-2 border-teal-500 hover:border-teal-600 px-3 py-2 rounded uppercase font-poppins font-medium">
                  <svg viewBox="0 0 24 24" className="inline w-4 h-4">
                    <path fill="currentColor" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
                  </svg> Details
                </button>
              </div>
              <div className="w-1/2 p-2">
                <button className="block w-full bg-white hover:bg-gray-100 text-teal-500 border-2 border-teal-500 px-3 py-2 rounded uppercase font-poppins font-medium">
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        </div>
          <div className="w-full md:w-1/3 p-2">
          <div className="bg-white shadow-lg hover:shadow-xl rounded-lg ">
            <div className="bg-gray-400 h-64 rounded-t-lg p-4 bg-no-repeat bg-center bg-cover"  >
              <div className="text-right">
                <button className="text-gray-300 hover:text-pink-500 p-2 rounded-full" >
                  <svg className="w-6 h-6" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="flex justify-between items-start px-2 pt-2">
              <div className="p-2 flex-grow">
                <h1 className="font-medium text-xl font-poppins">Product name</h1>
                <p className="text-gray-500 font-nunito">Short description here</p>
              </div>
              <div className="p-2 text-right">
                <div className="text-teal-500 font-semibold text-lg font-poppins">$100</div>
                <div className="text-xs text-gray-500 line-through font-poppins">$50</div>
              </div>
            </div>
            <div className="flex justify-center items-center px-2 pb-2">
              <div className="w-1/2 p-2">
                <button className="block w-full bg-teal-500 hover:bg-teal-600 text-white border-2 border-teal-500 hover:border-teal-600 px-3 py-2 rounded uppercase font-poppins font-medium">
                  <svg viewBox="0 0 24 24" className="inline w-4 h-4">
                    <path fill="currentColor" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
                  </svg> Details
                </button>
              </div>
              <div className="w-1/2 p-2">
                <button className="block w-full bg-white hover:bg-gray-100 text-teal-500 border-2 border-teal-500 px-3 py-2 rounded uppercase font-poppins font-medium">
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </Layout>
  )
}
